import client from '../client'

export default async function getModernFilterMenu() {
    const response = await client.post<any>(`/api/search`, {
        requestApi: 'modernFilterMenuUri',
    })

    return response.data
}
